<ion-list class="menu-list">
  <ion-item *ngFor="let button of buttons;" (click)="clickMenu(button)" lines="full" detail-none>
    <ion-icon class="pop-menu-icon" name="{{button.icon}}" color="{{button.iconColor}}"></ion-icon>
    <ion-label>{{button.text}}</ion-label>
  </ion-item>
</ion-list>